import React from 'react';
import classNames from 'classnames';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { CastState, ForecastTricastState } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/ForecastTricast/ForecastTricast.state';
import { ForecastTricastTitle } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/ForecastTricast/ForecastTricast.style';
import { useAsObservableSource } from 'mobx-react-lite';


function isDisabledColumns(state: CastState, place: number): boolean {

    if (place === 0 && state.has(0) ) {
        return false;
    } else if (place !== 0 && state.has(0)) {
        return true;
    }

    return  state.has(place);
}

function isDisabledRows(state: CastState, selectionId: number): boolean {
    let selectionIsSelected = false;
    state.forEach( legItem => {
        if (legItem[0]?.selectionId === selectionId) {
            selectionIsSelected = true;
        }
    });

    return selectionIsSelected;
}

// function isSelected(map) {
//     let selected = List();
//     map.delete('any').forEach(
//         (l, place) => {
//             selected = selected.push({
//                 place,
//                 selection: l.getIn([ 'selection', 'id' ])
//             });
//         }
//     );
//     map.getIn([ 'any' ], List()).forEach(
//         l => {
//             selected = selected.push({
//                 place: 'any',
//                 selection: l.getIn([ 'selection', 'id' ])
//             });
//         }
//     );
//
//     return selected;
// }

interface FixedPlaceColumnPropsType {
    event: EventModel,
    market: MarketModel,
    title: string,
    places: number,
    forecastTricastState: ForecastTricastState
    selections: Array<SelectionModel>
}

//TODO: Refactor component after apply betslipState from wesbite
export const FixedPlaceColumn = observer('FixedPlaceColumn', (propsIn: FixedPlaceColumnPropsType) => {
    const props = useAsObservableSource(propsIn);
    const marketSelections = props.selections;
    const places = props.title === 'Forecast' ? 2 : 3;
    const state = props.title === 'Forecast' ? props.forecastTricastState.forecast : props.forecastTricastState.tricast;

    const getColumn = (): Array<JSX.Element> => {
        const components: Array<JSX.Element> = [];
        for (let i = 1; i <= places; i++) {
            components.push(
                <div key={i} className='fixed-place-column'>
                    {
                        marketSelections.map(selection => getSelection(
                            selection,
                            props.market,
                            props.event,
                            props.forecastTricastState,
                            props.title.toLowerCase(),
                            i,
                            isDisabledColumns(state, i) || isDisabledRows(state, selection.id)
                        ))
                    }
                </div>
            );
        }

        components.push(
            <div key='any' className='fixed-place-column'>
                {
                    marketSelections.map(selection => getSelection(
                        selection,
                        props.market,
                        props.event,
                        props.forecastTricastState,
                        props.title.toLowerCase(),
                        0,
                        isDisabledColumns(state, 0) || isDisabledRows(state, selection.id)
                    ))
                }
            </div>
        );

        return components;
    };

    return (
        <div className='fixed-place-column fixed-place-column--compound'>
            <ForecastTricastTitle>
                { props.title }
            </ForecastTricastTitle>
            <div className='fixed-place-column-compound'>
                {getColumn()}
            </div>
        </div>
    );
});


function getSelection(selection: SelectionModel, market: MarketModel, race: EventModel, forecastTricastState: ForecastTricastState, key: string, place: number,  disabled: boolean) {
    if (selection.resultType === 'void') {
        return (
            <span key={ key }
                className='fixed-place-column__selection fixed-place-column__selection--not-running'>
                NR
            </span>
        );
    }

    if (!selection.display) {
        return <span key={ key } className='fixed-place-column__selection'>-</span>;
    }

    const isSuspended = !race.active || !market.active || !selection.active;

    // const cls = classNames('selection fixed-place-column__selection', {
    //     'fixed-place-column__selection--disabled': !selected && disabled,
    //     'fixed-place-column__selection--selected': selected,
    //     'selection--suspended': isSuspended
    // });

    const cls = classNames('selection fixed-place-column__selection', {
        'fixed-place-column__selection--disabled': disabled,
        'selection--suspended': isSuspended
    });

    //TODO: comments for tests
    // const isUnnamedFavourite = selection.templateId === 'unnamed-favourite';
    // const price = selection.price || (isUnnamedFavourite || market.sp ? 'sp' : undefined);

    const placeName = (): string => {
        switch (place) {
        case 1:
            return '1st';
        case 2:
            return '2nd';
        case 3:
            return '3rd';
        case 0:
            return 'Any';
        default:
            return 'N/N';
        }
    };

    return (
        <button
            key={ key + selection.id + place}
            className={ cls }
            onClick={ () => forecastTricastState.onSelect(key, place, race, market, selection) }
        >
            {placeName()}
        </button>
    );
}
